/* 
* Icons.js - Componente para cargar los iconos de Font Awesome 
* Este archivo carga el CSS de Font Awesome desde un CDN para usar en toda la aplicación
*/

import React, { useEffect } from 'react';

const Icons = () => {
    useEffect(() => {
        // Cargar Font Awesome desde CDN
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
        link.integrity = 'sha512-1ycn6IcaQQ40/MKBW2W4Rhis/DbILU74C1vSrLJxCq57o941Ym01SwNsOMqvEBFlcgUa6xLiPY/NS5R+E6ztJQ==';
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return null;
};

export default Icons;
